import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDBodyText, FDHeadlineText, FDLabelText } from '@facet-wealth/design';

export const impactOverrides = buildFacetDesignOverride()
  .nameOverride('headline', {
    _component: () => FDLabelText,
    _customProps: { size: 'md' },
  }, overrideReadOnly)
  .nameOverride('description', {
    _component: () => FDBodyText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride('value', {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .done();
